export const layout = {
  employees: 'Employees',
  idCards: 'Id Cards',
  terminals: 'Terminals',
  uniforms: 'Uniforms',
  attendanceLogs: 'Attendance Logs',
  languages: 'Languages',
  announcements: 'Announcements',
}
